module.exports = __webpack_public_path__ + "static/pic26-89636462cb1021aaaf8da6745eabe693.jpg";